import { formatScaledIndicatorValue } from "helpers/indicatorValueHelper";

const flattenSpreadsheetLabel = (label) =>
	String(label || "")
		.replace(/\n+/g, " | ")
		.trim();

const formatScaledCellForClipboard = (cell) => {
	if (!cell || cell.value === "" || cell.value == null) return "";
	return formatScaledIndicatorValue(cell.value, cell.decimals ?? 2);
};

/**
 * Monta TSV com cabeçalhos de coluna/linha para colar no Excel.
 * Usa a seleção atual do react-spreadsheet (selection.toRange).
 */
export const buildSpreadsheetCopyTsv = ({
	data,
	selection,
	columnLabels,
	rowLabels,
}) => {
	if (!selection || !Array.isArray(data) || data.length === 0) return null;

	const range = selection.toRange(data);
	if (!range) return null;

	const { start, end } = range;
	const header = [""];
	for (let column = start.column; column <= end.column; column += 1) {
		header.push(flattenSpreadsheetLabel(columnLabels?.[column]));
	}

	const lines = [header.join("\t")];
	for (let row = start.row; row <= end.row; row += 1) {
		const cells = [flattenSpreadsheetLabel(rowLabels?.[row])];
		for (let column = start.column; column <= end.column; column += 1) {
			cells.push(formatScaledCellForClipboard(data[row]?.[column]));
		}
		lines.push(cells.join("\t"));
	}

	return lines.join("\n");
};
